<template>
  <div class="form-item-wrap">
    <label>{{ label }}</label>
    <div class="form-item-value">
      <slot name="content">
        <el-tooltip :content="getObjType(value) == 'array' ? value.map(item => item[keyCode] || item).join('、') : String(value)" placement="top" effect="light">
          <template v-if="getObjType(value) == 'array'">
            <span>{{value.map(item => item[keyCode] || item).join("、")}}</span>
          </template>
          <span v-else>{{ value }}</span>
        </el-tooltip>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number, Array],
    },
    keyCode: {
      type: String,
      default: "name"
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
@labelColor: #3e7fd4;
@backgroundColor: #f3f7ff;
.form-item-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  font-size: 14px;
  label {
    height: 100%;
    min-height: 40px;
    background: @backgroundColor;
    padding: 4px 14px;
    box-sizing: border-box;
    width: 116px;
    color: @labelColor;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-right: 1px solid #e8e8e8;
    line-height: 1.5;
  }
  .form-item-value {
    width: calc(100% - 116px);
    span {
      display: block;
      width: 100%;
      padding: 0 14px;
      box-sizing: border-box;
      line-height: normal;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>